<template>
  <section class="index-wrap">
    <common-header />

    <div class="content">
      <div class="wrapper">
        <img :src="require('@/assets/images/logo-b.png')" class="logo-b" alt="" />

        <div class="introduce">
          <img :src="require('@/assets/images/desc.png')" alt="" />
          <p>飞布是广州百景信息科技服务有限公司旗下的智慧物流品牌，致力于整合行业及社会运输力量，为纺织行业上下游客户提供基于Saas的一站式系统服务，让科技融入到纺织行业的货物流转中，为行业提速，为用户增效降本，共建行业生态。
          </p>
        </div>

        <div class="advantage">
          <div class="advantage-item">
            <img :src="require('@/assets/images/ic-time.png')" class="icon" alt="time">
            <h3>全天24h高效运输</h3>
            <p>
              覆盖全国的车队用户提供服务 <br>
              我们的仓库就在客户身边 <br>
              每个节点和异常都清晰 <br>
            </p>
          </div>
          <div class="advantage-item">
            <img :src="require('@/assets/images/ic-location.png')" class="icon" alt="location">
            <h3>系统更强大</h3>
            <p>
              基于LBS及智能硬件的轨迹 <br>
              车队控制台实时监控 <br>
              货物流向随时随地看 <br>
            </p>
          </div>
          <div class="advantage-item last">
            <img :src="require('@/assets/images/ic-value.png')" class="icon" alt="value">
            <h3>服务体现价值</h3>
            <p>
              可定制化的系统模块 <br>
              用户就是品牌的传递者 <br>
              省下的时间都是利润 <br>
            </p>
          </div>
        </div>
      </div>
    </div>

    <common-footer/>
  </section>
</template>

<script>
import commonHeader from '@/components/header'
import commonFooter from '@/components/footer'
export default {
  name: 'index',
  components: { commonHeader, commonFooter }
}
</script>

<style lang="postcss" scoped>
.content {
  height: 920px;
  background: #FAFBFF url("~@/assets/images/conten-bg.png") no-repeat center;
  overflow: hidden;
}
.content .wrapper {
  position: relative;
}
.content .introduce {
  margin-top: 120px;
  width: 585px;
  line-height: 2;
}
.content .logo-b {
  position: absolute;
  right: 200px;
  top: 6px;
}
.content .introduce img {
  margin-bottom: 16px;
}

.advantage {
  margin-top: 120px;
}
.advantage-item {
  float: left;
  width: 386px;
  min-height: 132px;
  background: #EFF3FD;
  border-radius: 8px;
  margin-right: 20px;
  padding-left: 110px;
  position: relative;
}
.advantage-item.last {
  margin-right: 0;
}
.advantage-item .icon {
  position: absolute;
  left: 30px;
  top: -10px;
}
.advantage-item h3 {
  font-size: 16px;
  font-weight: 700;
  margin: 16px 0;
}
.advantage-item p {
  font-size: 13px;
  line-height: 1.6;
  opacity: 0.8;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/module/index.vue